import React from "react";
import "./Plans.css";
import { plansData } from "../../data/plansData"; // Corrected import statement
import Whitetick from "../../assets/whiteTick.png"; // Ensure this is a white checkmark image

const Plans = () => {
  return (
    <div className="plans-container" id="plans"> {/* Added id for navigation */}
      {/* Blur effects - often added for visual depth, not directly in image but common */}
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>

      <div className="programs-header">
        <span className="stroke-text">Ready to Start</span> {/* Changed class */}
        <span>Your Journey</span>
        <span className="stroke-text">now withus</span> {/* Changed class */}
      </div>

      {/* Plans Card Section */}
      <div className="plans">
        {plansData.map((plan, i) => (
          <div className={plan.name === "PREMIUM PLAN" ? "plan premium" : "plan"} key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>${plan.price}</span>

            <div className="features">
              {plan.features.map((feature, index) => (
                <div className="feature" key={index}> {/* Added key for list items */}
                  <img src={Whitetick} alt="Checkmark" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div>
              <span>See more benefits &rarr;</span> {/* Used HTML entity for arrow */}
            </div>
            <button className="btn">Join Now</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;